import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Divider } from "antd";
import { CrownOutlined } from "@ant-design/icons";
import { formatDateOnly } from "Common/Components/FormatDateTime";

const { Title, Text } = Typography;

const CertificateOfCompletion = ({ certificate = null }) => {
  if (!certificate) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        padding: "24px",
        background: "#f5f5f5",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 900,
          border: "1px solid #d9d9d9",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          padding: 0,
          overflow: "hidden",
        }}
        variant="borderless"
      >
        {/* Header Section */}
        <div
          style={{
            background: "#1C1917",
            padding: "24px",
            textAlign: "center",
            color: "white",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CrownOutlined style={{ fontSize: "32px", marginRight: "16px", color: "#faad14" }} />
            <Title level={3} style={{ color: "white", margin: 0 }}>
              CORIQPRO
            </Title>
          </div>
          <Text style={{ color: "rgba(255, 255, 255, 0.65)" }}>Learning Management System</Text>
        </div>

        {/* Certificate Content */}
        <div
          style={{
            padding: "60px",
            textAlign: "center",
            background: "white",
          }}
        >
          <Text type="secondary" style={{ display: "block", marginBottom: "8px" }}>
            This is to certify that
          </Text>

          <Title
            level={2}
            style={{
              marginBottom: "40px",
              fontWeight: 600,
              color: "#1d1d1d",
            }}
          >
            {certificate.firstName} {certificate.lastName}
          </Title>

          <Divider style={{ borderTop: "1px solid #d9d9d9" }}>
            <Text strong style={{ fontSize: "18px" }}>
              has successfully completed
            </Text>
          </Divider>

          <Title
            level={3}
            style={{
              color: "#9A6B0E",
              margin: "40px 0 20px",
              fontWeight: 500,
            }}
          >
            {certificate.trainingTitle ||
              certificate.courseName ||
              certificate.courseTitle ||
              certificate.title ||
              "Training Program"}
          </Title>

          <div
            style={{
              marginBottom: "24px",
              padding: "16px",
              background: "#fafafa",
              borderLeft: "4px solid #9A6B0E",
              borderRight: "4px solid #9A6B0E",
            }}
          >
            <Text strong style={{ fontSize: "16px" }}>
              Score: {Number(certificate.finalScore ?? 0).toFixed(2)}%
            </Text>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "40px",
              flexWrap: "wrap",
              color: "#595959",
            }}
          >
            <Text>
              <strong>Issue Date:</strong>{" "}
              {formatDateOnly(
                certificate.createdOn || certificate.issuedOn || certificate.completedOn
              )}
            </Text>
            {certificate.id != null && (
              <Text>
                <strong>Certificate ID:</strong> {certificate.id}
              </Text>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

CertificateOfCompletion.propTypes = {
  certificate: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    trainingTitle: PropTypes.string,
    courseName: PropTypes.string,
    courseTitle: PropTypes.string,
    title: PropTypes.string,
    finalScore: PropTypes.number,
    createdOn: PropTypes.string,
    issuedOn: PropTypes.string,
    completedOn: PropTypes.string,
  }),
};

export default CertificateOfCompletion;
